<template>
  <div class="amount-input">
    <el-input @input="doThis" ref="input" placeholder="请选择日期" :value="value">
      <i slot="prefix" class="">$</i>
      <template slot="prepend">Http://</template>
    </el-input>
  </div>
</template>
<script>
  export default {
    props: ['value'],
    data() {
      return {
      }
    },
    mounted() {
    },
    methods: {
      doThis(val) {
        this.$emit('input', val)
      }
    },
  }

</script>

<style lang="scss">
.amount-input{
    .el-input__prefix{
        line-height:40px;
        left: 0;
        width: 40px;
        font-weight: bold;
        color: #000;
    }
}

</style>
